import React, {useContext} from 'react';
import {FiChevronDown} from "react-icons/fi";
import {ProjectContext} from "../../context/project-context";
import {Link, useNavigate} from "react-router-dom";
import {Menu, MenuButton, MenuItem, MenuItems, Transition} from "@headlessui/react";
import logo from '../../assets/images/logo-sentry.png';
import {FaBars} from "react-icons/fa";

const Header = ({title, menusIsOpen, setMenusIsOpen}) => {
    const {user, logout} = useContext(ProjectContext);
    const navigate = useNavigate();

    const logoutHeader = () => {
        logout(() => {
            navigate("/login")
        });
    }

    return (
        <nav className="fixed top-0 z-50 w-full bg-menu">
            <div className="flex items-center justify-between">
                <div className="flex items-center justify-start rtl:justify-end">

                    <div
                        className="ms-3 sm:ms-0 sm:w-[255px] p-[3px] text-center text-xl font-bold text-yellow-500 sm:border-b-2 sm:border-r-2 border-gray-700">
                        <div className={"flex items-center justify-center"}>
                            <img className={"w-[30px] h-[35px] mr-2"} src={logo} alt=""/>
                            <span className={"text-[18px]"}>SISTEMA INTERNO</span>
                        </div>
                    </div>

                    <span className={"text-[18px] ms-2 text-gray-700 bg-yellow-500 w-[30px] h-[30px] flex justify-center items-center rounded-3xl cursor-pointer"} onClick={() => setMenusIsOpen(!menusIsOpen)}>
                        <FaBars/>
                    </span>
                    <span className={"text-[18px] text-white sm:block ml-[10px] hidden"}>{title.toUpperCase()}</span>
                </div>
                <div className="flex items-center">
                    <Menu as="div" className="flex items-center ms-3 text-white">
                        <div>
                            <MenuButton type="button" className="flex">
                                <span className={"text-[15px] p-2"}>{user?.name}</span>
                                <span className="p-2 transform transition-transform text-[18px]">
                                    <FiChevronDown/>
                                </span>
                            </MenuButton>
                        </div>
                        <Transition
                            enter="transition ease-out duration-75"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <MenuItems
                                anchor="bottom end"
                                className="w-40 origin-top-right rounded border border-white/5 p-1 text-sm/6 bg-[#30353e] [--anchor-gap:var(--spacing-1)] focus:outline-none z-10 text-white"
                            >
                                <MenuItem>
                                    <Link className="group flex w-full items-center text-slate-50 gap-2 rounded-lg p-1 hover:text-yellow-300" to="/my-user">
                                        Alterar senha
                                    </Link>
                                </MenuItem>
                                <MenuItem>
                                    <span className="block cursor-pointer hover:text-yellow-300 p-1" onClick={logoutHeader}>
                                        Sair
                                    </span>
                                </MenuItem>
                            </MenuItems>
                        </Transition>
                    </Menu>
                </div>
            </div>
        </nav>
    )
};

export default Header;